import Dexie from 'dexie';

const db = new Dexie('svarejo');

// Tabelas com {Local} não existem na nuvem, e são normalmente usadas apenas para reexibição.

db.version(7).stores({
  parametro: `
  ++id,
  paridnuvem,
  pardataalteracao,
  datainportacao,
  empresa,
  senhaatual,
  linkwebservice,
  databaixado,
  idvendedorlogado`
  ,
  empresa: `
  ++idempresa,
  empidnuvem,
  idEmpresa,
  NomeEmpresa,
  NomeFantasia,
  Cnpj,
  databaixado`
  ,

  destinoitem: `
  iddestinoitem,
  deiidnuvem,
  deidataalteracao,
  descricao,
  databaixado`
  ,
  formapagto: `
  idformapagto,
  fopidnuvem,
  fopdataalteracao,
  descricao,
  databaixado`
  ,
  tipopedidovenda: `
  idtipopedidovenda,
  tpvidnuvem,
  tpvdataalteracao,
  descricao,
  idplanopagto,
  idformapagto,
  iddestinoitem,
  databaixado`
  ,
  planopagamento: `
  idplanopagto,
  plpidnuvem,
  plpdataalteracao,
  descricao,
  condicaovalorde,
  condicaovalorate,
  tipoplano,
  databaixado`
  ,
  vendedor: `
  idvendedor,
  vedidnuvem,
  veddataalteracao,
  codigo,
  nome,
  senha,
  valormeta,
  ultimologado,
  databaixado`
  ,
  cliente: `
  idcliente,
  cliidnuvem,
  clidataalteracao,
  nome,
  nomefantasia,
  cidade,
  cnpj_cpf,
  databaixado`
  ,
  pedido: `
  ++idpedido,
  idpedidoback,
  idorcamentoback,
  pedidnuvem,
  peddataalteracao,
  orcamento,
  idcliente,
  idvendedor,
  data,
  datatransmissao,
  numero,
  idtipopedidovenda,
  atendido,
  dataconfirmacao,
  datafaturamento,
  datacancelamento,
  idpedidoditemd`
  ,
  pedidoitem: `
  ++idpedidoitem,
  peiidnuvem,
  idpedidoback,
  idorcamentoback,
  peidataalteracao,
  idcortamanhofinal,
  idpedido,
  atendido,
  idpedidoditemd`
  ,
  produtosugerido: `
  idprodutosugerido,
  prsidnuvem,
  prsdataalteracao,
  idgrupo,
  descricao`
  ,
  totalpedido: `
  idtotalpedido,
  topidnuvem,
  topdataalteracao,
  data,
  valor`
  ,
  visita: `
  ++idvisita,
  visidnuvem,
  visdataalteracao,
  datavisita,
  datadigitacao,
  motivo,
  observacao,
  idcliente,
  latitude,
  longitude,
  atendido`
  ,
  financeiro: `
  idfinanceiro,
  finidnuvem,
  findataalteracao,
  idcliente,
  documento,
  emissao,
  vencimento,
  saldo,
  datafinal,
  databaixado`
  ,
  venda: `
  ++idlocal, 
  idvenda,
  venidnuvem,
  vendataalteracao,
  idcliente,
  idcortamanhofinal,
  data,
  privenda,
  cidade,
  idvendedor,
  iditensvenda,
  idpedidovendaitens,
  databaixado`
  ,
  grupo: `
  idgrupo,
  gruidnuvem,
  grudataalteracao,
  descricao,
  databaixado`
  ,
  produto: `
  idproduto,
  proidnuvem,        
  prodataalteracao,
  idcortamanhofinal,
  codigointerno,
  codigofuncao,
  descricaogrupo,
  estoque,
  idgrupo,
  ctfqtdecomboleva,
  ctflimitepromocoesporvenda,
  databaixado`
  ,
  imagem: `
  ++id,
  idproduto,
  idcortamanhofinal`,

  clientelead: `
  ++id,
  cllidclienteprecadastro,
  cllnome,
  cllnomefantasia,
  cllcidade,
  cllcnpjCpf,
  cllidvendedor,
  clldatadigitacao`
});

db.open().then(function (db) {
  console.log('db | aberto: ', db);
}).catch (function (err) {
  console.log('db | erro: ', err)
});

export default db;
